export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10391.15d4e33c.jpg";